import React, { useEffect } from "react";
import { FunnelChart } from "chartjs-chart-funnel";
import NoDataComponent from "../../../reusableComponents/noDataComponent/NoDataComponent";
import { funnelColorSchema } from "../../../reusableComponents/constants";
import { Skeleton } from "@mui/material";

const FunnelChartComponent = ({ checkoutFunnelAnalysis, backgroundColor }) => {
  const id = "canvas" + Math.random();
  let backgroundColorSchema = funnelColorSchema;
  useEffect(() => {
    const canvas = document.getElementById(id);
    if (canvas) {
      const context = canvas.getContext("2d");
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.clearRect(0, 0, canvas.width, canvas.height);

      if (!checkoutFunnelAnalysis || checkoutFunnelAnalysis?.length === 0) {
        return;
      }

      const chartData = checkoutFunnelAnalysis?.slice(0, 5);
      // const labels = chartData?.map((data) => data?.eventName);
      // const dataValues = chartData?.map((data) => data?.eventPercent);
      const labels = checkoutFunnelAnalysis?.map((data) => data?.eventName);
      const dataValues = checkoutFunnelAnalysis?.map(
        (data) => data?.eventPercent
      );

      const chart = new FunnelChart(context, {
        data: {
          labels: labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: backgroundColorSchema.map((item) => item),
              datalabels: {
                formatter: (v) => v.toLocaleString(),
                font: {
                  family: "Poppins",
                },
                position: "bottom",
              },
            },
          ],
        },
        options: {
          font: {
            family: "Poppins",
          },
          maintainAspectRatio: false,
          indexAxis: "y",
          plugins: {
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (context) {
                  let label;
                  if (context?.formattedValue) {
                    label = context.formattedValue + "%";
                  }
                  return label;
                },
              },
            },
            legend: {
              display: true,
              position: "right",
              align: "end",
              labels: {
                font: {
                  family: "Poppins",
                  size: "12px",
                  style: "normal",
                  weight: "400",
                  height: "14px",
                },
                boxWidth: 12,
                usePointStyle: true,
                padding: 27,
                boxWidth: 100,
                generateLabels: (chart) => {
                  const data = chart?.data;
                  if (data?.labels?.length && data?.datasets?.length) {
                    return data.labels.map((label, index) => {
                      const dataset = data?.datasets[0];
                      const value = dataset?.data[index];
                      const backgroundColor = dataset?.backgroundColor[index];
                      return {
                        text: `${label}`,
                        fillStyle: backgroundColor,
                        borderWidth: 0,
                        pointStyle: "circle",
                      };
                    });
                  }
                  return [];
                },
              },
            },
          },
          // plugins: [ChartDataLabels],
        },
      });

      return () => {
        chart.destroy();
      };
    }
  }, [checkoutFunnelAnalysis]);

  return (
    <>
      {checkoutFunnelAnalysis ? (
        checkoutFunnelAnalysis?.length !== 0 ? (
          <canvas
            className="funnel-div"
            style={{ width: "100% !important" }}
            id={id}
          />
        ) : (
          <NoDataComponent />
        )
      ) : (
        <div
          className="funnel-skeleton"
          style={{ width: "100%", height: "100%" }}
        >
          <Skeleton
            variant="rounded"
            animation="wave"
            width={"100%"}
            height={"100%"}
          />
        </div>
      )}
    </>
  );
};

export default FunnelChartComponent;
